import React, { useContext, useState } from "react";

import avatar from "../../images/avatar.png";
import { toFarsiNumber } from "../../helper/helper";
import { BsFillReplyFill } from "react-icons/bs";
import AcademyReplyComment from "./AcademyReplyComment";
import SendComment from "./SendComment";
import { getItemStorage } from "../../Localstorage/useLocalStorage";
import { UserData } from "../../contexts/UserInfoContext";

const AcademyComment = ({ data, lesson_id, type }) => {
  const { user } = useContext(UserData);
  const [open, setOpen] = useState(false);

  const token = getItemStorage("token");

  const openReply = () => {
    token && setOpen(!open);
  };

  return (
    <div className="w-full flex gap-5 h-auto bg-gray-800 p-4 rounded-xl">
      <div className="hidden flex-col lg:flex items-center gap-2">
        <img
          src={data.avatar ? `https://api.myunibest.ir/${data.avatar}` : avatar}
          className="min-w-[40px] h-10 md:w-14 md:h-14 rounded-full"
          alt=""
        />
        <span className="text-xs bg-blue-gray-700 text-white px-4 py-1 text-center rounded-md">
          {data.user.role === 2
            ? "ادمین"
            : data.user.role === 3
            ? "مشاور"
            : "کاربر"}
        </span>
      </div>

      <div className="w-full flex flex-col gap-6">
        {/* name */}

        <div className="flex items-center gap-2">
          <div className="flex flex-col lg:hidden items-center gap-2">
            <img
              src={
                data.avatar ? `https://api.myunibest.ir/${data.avatar}` : avatar
              }
              className="min-w-[40px] h-10 md:w-14 md:h-14 rounded-full"
              alt=""
            />
          </div>

          <div className="w-full flex items-center justify-between">
            <div className="flex flex-col gap-1">
              <span className="text-lg text-gray-200">
                {data.user.name + " " + data.user.family_name}
              </span>

              <div className="flex items-center gap-2">
                <span className="text-[11px] lg:hidden bg-blue-gray-700 text-white px-3 py-1 text-center rounded-md">
                  {data.user.role === 2
                    ? "ادمین"
                    : data.user.role === 3
                    ? "مشاور"
                    : "کاربر"}
                </span>
                <span className="text-gray-400 text-xs">
                  {new Intl.DateTimeFormat("fa-IR", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  }).format(new Date(data.date))}
                </span>
              </div>
            </div>

            {type === "comment" ? (
              <button onClick={openReply} className="relative group">
                {!user?.user?.id && (
                  <div className="block bg-gray-700 translate-y-7 opacity-0 group-hover:opacity-100 transition-all duration-300 group-hover:translate-y-0 p-2 -top-10 left-0 w-44 absolute rounded-lg text-xs text-red-600">
                    برای پاسخ به دیدگاه وارد شوید
                  </div>
                )}

                <BsFillReplyFill className="text-4xl text-gray-400" />
              </button>
            ) : (
              type === "QA" &&
              user?.user?.role === 2 && (
                <button onClick={openReply}>
                  <BsFillReplyFill className="text-4xl text-gray-400" />
                </button>
              )
            )}
          </div>
        </div>

        {/* message */}
        <p className="text-gray-200 text-sm md:text-base leading-7 break-words">
          {data.message}
        </p>

        {open && user?.user?.id && (
          <SendComment
            reply={true}
            data={lesson_id}
            user={data.user}
            comment_id={data.id}
            setOpen={setOpen}
            type={type}
          />
        )}

        {/* reply comments */}
        {data.replies &&
          data.replies.map((rep) => <AcademyReplyComment data={rep} />)}
      </div>
    </div>
  );
};

export default AcademyComment;
